<template>
  <BLayoutView
    :back-route="backRoute"
    :title="pageTitle"
    :skeleton="isLoadingAsyncData"
    :save-menu-list="null"
  >
    <template #form>
      <ComponentForm
        ref="form"
        v-bind="viewTypeOptions"
        :data="viewTypeOptions.isCreate ? void 0 : single"
        :loading="isLoading"
        :editable="editable"
        :skeleton="isLoadingAsyncData"
        class="my-4"
        @save="onSave"
        @delete="onDelete(single)"
      >
        <template v-if="isEditable" #save-menu>
          <v-row dense class="mt-4">
            <v-spacer />
            <v-col cols="auto">
              <BFormButtons
                :edit-route="editRoute"
                :loading="isLoading"
                :save-menu-list="saveMenuList"
                :skeleton="isLoadingAsyncData"
                :saveable="saveable"
                :editable="editable"
                :deletable="deletable"
                @delete="onDelete(single)"
                @save-menu="onSave"
              />
            </v-col>
          </v-row>
        </template>
      </ComponentForm>

      <template v-if="!viewTypeOptions.isCreate && single" />
    </template>
  </BLayoutView>
</template>

<script>
import { createViewMixin } from '@/helpers/mixins/createViewMixin'
import { createDeletableMixin } from '@/helpers/mixins/createDeletableMixin'
import { lkPublicationPermissions as Permissions } from '@/helpers/enums/permission-models'
import { MarksModel as Model } from './Model'
import { marksStoreModule as StoreModule } from './store'
import { MARKS_ROUTES as ROUTES } from './utils'

import BLayoutView from '@/components/layouts/BLayoutView.vue'
import BFormButtons from '@/components/common/BFormButtons.vue'
import ComponentForm from './components/MarksForm.vue'
import * as VIEW_TYPES from '@/helpers/enums/view-types'

const mixinOptions = { Model, StoreModule, ROUTES }
const viewMixin = createViewMixin(mixinOptions)
const deletableMixin = createDeletableMixin(mixinOptions)

/** @typedef { import('@/helpers/mixins/createViewMixin').ViewMixin<any, StoreModule> } View */
/** @typedef { import('@/helpers/mixins/createDeletableMixin').DeletableMixin<any, StoreModule> } Deletable */

export default {
  name: 'ViewCollectorPublicationsView',
  $_veeValidate: {
    /** @type 'new' */
    validator: 'new',
  },
  components: {
    BLayoutView,
    BFormButtons,
    ComponentForm,
  },
  mixins: [viewMixin, deletableMixin],
  data: () => ({
    backRoute: { name: ROUTES.LIST },
    saveMenuList: [
      {
        name: 'save',
        label: 'Сохранить',
      },
    ],
  }),
  computed: {
    viewTypeOptions() {
      const { viewType } = this
      return !this.$access(Permissions.edit)
        ? {
          isCreate: false,
          isEdit: false,
          isView: true,
        }
        : {
          isCreate: viewType === VIEW_TYPES.CREATE,
          isEdit: viewType === VIEW_TYPES.EDIT,
          isView: viewType === VIEW_TYPES.VIEW,
        }
    },
    isEditable() {
      return this.$access(Permissions.edit)
    },
    createRoute() {
      return {
        name: ROUTES.CREATE,
      }
    },
    editRoute() {
      return {
        name: ROUTES.EDIT,
        props: { id: this.id },
      }
    },
  },
  methods: {
    async onSave(type) {
      const form = await this.$refs.form.onSubmit()
      const result = await this.onSubmit(form)
      // this.$refs.form.onReset()

      const { id } = result
      const editRoute = { name: ROUTES.EDIT, params: { id } }
      this.toSave(this.backRoute, this.createRoute, editRoute, type)
      this.$notice.info(
        'Результаты загружаются. После завершения загрузки вы получите сообщение в разделе уведомления',
      )
    },
  },
}
</script>
